import React, { Children } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Globe, FileText, ShieldCheck, ArrowRight } from 'lucide-react';
import { Constellation } from './Constellation';
export function Hero() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section id="home" className="relative pt-32 pb-20 md:pt-48 md:pb-32 overflow-hidden" data-id="element-117">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-118">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-119">
          <motion.div variants={containerVariants} initial="hidden" animate="visible" className="z-10" data-id="element-120">
            <motion.div variants={itemVariants} className="flex items-center gap-4 mb-6" data-id="element-121">
              <div className="w-12 h-[2px] bg-gold" data-id="element-122" />
              <span className="text-gold font-bold text-xs tracking-widest uppercase" data-id="element-123">
                Global Procurement & Strategic Sourcing
              </span>
            </motion.div>

            <motion.h1 variants={itemVariants} className="text-5xl md:text-7xl font-extrabold leading-[1.1] tracking-tighter mb-8" data-id="element-124">
              <span className="text-white" data-id="element-125">
                Connecting Global Suppliers to{' '}
              </span>
              <span className="text-slate-500" data-id="element-126">
                International Procurement Opportunities
              </span>
            </motion.h1>

            <motion.p variants={itemVariants} className="text-lg text-slate-400 mb-10 max-w-xl leading-relaxed" data-id="element-127">
              We are an independent procurement consultancy facilitating
              sourcing, supplier verification, and tender coordination for
              large-scale institutional projects worldwide. We connect
              manufacturers, exporters, and distributors with procurement
              opportunities relating to multilateral, government-backed, and
              African Union (AU)-funded programmes across Africa, Asia, the
              Middle East, and beyond.
            </motion.p>

            <motion.div variants={itemVariants} className="flex flex-wrap items-center gap-4 mb-12" data-id="element-128">
              <Link to="/pre-qualification" className="bg-gold hover:bg-gold-light text-navy font-semibold px-8 py-4 rounded flex items-center gap-2 transition-colors" data-id="element-129">
                Pre-Qualification Form <ArrowRight size={18} data-id="element-130" />
              </Link>
              <Link to="/services" className="border border-navy-border hover:border-gold hover:text-gold text-white font-semibold px-8 py-4 rounded transition-colors" data-id="element-131">
                Our Services
              </Link>
            </motion.div>

            <motion.div variants={itemVariants} className="flex flex-wrap gap-3" data-id="element-132">
              {[{
              icon: Globe,
              label: 'Global Sourcing'
            }, {
              icon: FileText,
              label: 'Tender Support'
            }, {
              icon: ShieldCheck,
              label: 'Supplier Verification'
            }].map((pill, i) => <div key={i} className="flex items-center gap-2 bg-navy-card border border-navy-border rounded-full px-4 py-2 text-sm text-slate-300" data-id="element-133">
                  <pill.icon size={16} className="text-gold" data-id="element-134" />
                  <span data-id="element-135">{pill.label}</span>
                </div>)}
            </motion.div>
          </motion.div>

          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 1,
          delay: 0.5
        }} className="relative h-[500px] lg:h-[600px] w-full" data-id="element-136">
            <Constellation data-id="element-137" />
          </motion.div>
        </div>
      </div>
    </section>;
}